export function Clock({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 2.1748C12.7597 2.1748 15.8252 5.24029 15.8252 9C15.8252 12.7597 12.7597 15.8252 9 15.8252C5.24029 15.8252 2.1748 12.7597 2.1748 9C2.1748 5.24029 5.24029 2.1748 9 2.1748ZM8.72266 4.40234C8.04248 4.40234 7.48554 4.95952 7.48535 5.63965V8.71484C7.48535 9.61923 8.03664 10.5973 8.81836 11.0645H8.81934L11.1445 12.4521C11.3565 12.5847 11.5791 12.6299 11.7754 12.6299C12.1914 12.6298 12.6034 12.4209 12.8379 12.0283L12.8389 12.0293C13.2016 11.4353 13.0021 10.6728 12.4121 10.3252H12.4131L10.0908 8.93848C10.0878 8.93558 10.083 8.93135 10.0771 8.9248C10.0581 8.90336 10.0355 8.87145 10.0137 8.83301C9.99182 8.79459 9.97592 8.75803 9.9668 8.72949C9.9621 8.71476 9.9605 8.70603 9.95996 8.70312V5.63965C9.95978 5.00208 9.47021 4.47295 8.84863 4.40918L8.72266 4.40234Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.35"
        />
      </svg>
    </span>
  );
}
